import log from 'salvo-lite/log'

import ProductModal from '../components/ProductModal'

class collection {
    constructor (components) {
        log.debug('Collection', 'Constructing', this)
        this._components = components
    }

    onInit () {
        log.debug('Collection', 'Initiating', this)
        this.loadMoreProducts(this._components.getComponentsById('productLoadMore'))
    }

    loadMoreProducts (productLoadMore) {
        log.debug('Collection', 'Adding Load More Events', productLoadMore)
        if (!productLoadMore) {
            return false
        }
        productLoadMore._productContainer = productLoadMore._elem.parentNode.parentNode
        productLoadMore._triggerContainer = productLoadMore._elem.parentNode
        productLoadMore._products = document.querySelectorAll('.product-grid-item')
        productLoadMore._elem.addEventListener('load-more-start', e => {
            log.debug('Collection', 'Load More Started', e)
            productLoadMore._productContainer.style.height = productLoadMore._productContainer.scrollHeight + 'px'
        })
        productLoadMore._elem.addEventListener('load-more-complete', e => {
            log.debug('Collection', 'Load More Complete', e)
            log.debug('Collection', 'Product Grid Items', productLoadMore.productItems)
            productLoadMore._productContainer.removeChild(productLoadMore._triggerContainer)
            productLoadMore.productItems = e.detail.response.querySelectorAll('.product-grid-item')
            for (let item of productLoadMore.productItems) {
                log.debug('Collection', 'Load More Item', item)
                item.productModal = new ProductModal(window.__theme, item)
                item.productModal.init()
                item.classList.add('adding')
                productLoadMore._productContainer.appendChild(item)
            }
            if (!e.detail.stop) productLoadMore._productContainer.appendChild(productLoadMore._triggerContainer)
            productLoadMore._productContainer.style.height = productLoadMore._productContainer.scrollHeight + 'px'
            for (let item of productLoadMore.productItems) {
                item.classList.remove('adding')
            }
            productLoadMore._products = document.querySelectorAll('.product-grid-item')
            log.debug('Collection', 'All Items Added')
        })
    }
}

export default collection



// WEBPACK FOOTER //
// ./src/scripts/pages/Collection.js